import { create } from 'zustand'
// state para manejar el curso de learning actual


interface LearningState {
    currentCourse: any | null
    currentModule: any | null
    currentEvaluation: any | null
    setCurrentCourse: (course: any) => void
    updateCourseProgress: (updates: Partial<any>) => void
    setCurrentModule: (module: any) => void
    setCurrentEvaluation: (evaluation: any) => void
    clearCourse: () => void
    getCourse: () => any | null
    getModule: () => any | null
    getEvaluation: () => any | null


    currentModuleContext: any | null 
    setCurrentModuleContext: (context: any) => void 
    clearModuleContext: () => void

}
export const useLearningStore = create<LearningState>((set, get) => ({
    // Estado
    currentCourse: null,
    currentModule: null,
    currentEvaluation: null,
    currentModuleContext: null,
    
    // Acciones
    setCurrentCourse: (course) => {
        console.log('📚 [LearningStore] Setting current course:', course?._id)
        set({ currentCourse: course })
    },
    
    setCurrentModuleContext: (context) => set({ currentModuleContext: context }),

    clearModuleContext: () => set({ currentModuleContext: null }),

    updateCourseProgress: (updates) => {
        const currentCourse = get().currentCourse
        if (currentCourse) {
            const updatedCourse = { ...currentCourse, ...updates }
            console.log('📊 [LearningStore] Updating course progress:', updates)
            set({ currentCourse: updatedCourse })
        }
    },
    
    setCurrentModule: (module) => {
        console.log('📖 [LearningStore] Setting current module:', module?._id)
        set({ currentModule: module })
    },
    
    setCurrentEvaluation: (evaluation) => {
        console.log('✍️ [LearningStore] Setting current evaluation:', evaluation?._id)
        set({ currentEvaluation: evaluation })
    },
    
    clearCourse: () => {
        console.log('🗑️ [LearningStore] Clearing course')
        set({ currentCourse: null, currentModule: null, currentEvaluation: null })
    },
    
    // Getters
    getCourse: () => get().currentCourse,
    getModule: () => get().currentModule,
    getEvaluation: () => get().currentEvaluation,
}))